module.exports = __webpack_public_path__ + "static/img/fluent-document-table-24-regular.35e8c291.svg";